import { _, formatter } from '@zto/zpage'
import Decimal from "decimal.js"

/** 计算对比比例 */
export function calcCompareRatio(num1: number, num2: number) {
  if (num1 === 0) return num2 === 0 ? 0 : 1

  return parseFloat(((num2 - num1) / num1).toFixed(4))
}

/** 计算对比百分比 */
export function calcAndFormatComparePercentage(num1: number, num2: number) {
  const ratio = calcCompareRatio(num1, num2)

  return formatComparePercentage(ratio)
}

export function formatComparePercentage(ratio: number) {
  if (_.isNil(ratio)) return '--'

  const symbol = ratio < 0 ? '' : '+'
  const pnum = parseFloat((100 * ratio).toFixed(2))

  return `${symbol}${pnum}%`
}

export function formatPercentage(ratio: number, isPercentage?: boolean) {
  if (_.isNil(ratio)) return '--'

  let percentage = ratio

  if (!isPercentage) {
    percentage = parseFloat((100 * ratio).toFixed(2))
  }

  return `${percentage}%`
}

/** 格式化数字 */
export function formatDecimal(val: number, opts?: formatter.MoneyFormatOptions) {
  return formatter.yuanMoney(val, opts)
}


/** formatPrice 分转元（保留两位小数） */
export function formatPrice(value: number, prefix = '￥', emptyText = '--') {
  if (typeof value !== 'number') {
    return emptyText
  }
  return `${prefix}${(+ new Decimal(parseInt(''+value)).div(new Decimal(100))).toFixed(2)}`
}

/** formatInter 元转分 */
export function formatInter(value: number) {
  if (typeof value !== 'number') {
    return null
  }
  return parseInt(''+(new Decimal(value).mul(new Decimal(100))))
}

